// extracted by mini-css-extract-plugin
export default {"badge":"DocumentFileBadge_badge__dvPEX","dwg":"DocumentFileBadge_dwg__4nHZl","pdf":"DocumentFileBadge_pdf__iPdPq","discipline":"DocumentFileBadge_discipline__Uz5rr"};